import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';

import JourneyLegs from './JourneyLegs';

export default withRouter(injectIntl(JourneyLegs));
